module.exports = __webpack_public_path__ + "media/images/schedule-photo-7262b6e084e09af11a7c0137a8fee0d1.png";